module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "aboutUsHs"
    }
  }, [_c('div', {
    staticClass: "kt-banner"
  }, [_c('label', {
    staticClass: "love"
  }, [_vm._v("为爱设计")]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "loveUs"
  }, [_vm._v("Design for love")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "gs-title"
  }, [_vm._v("公司简介"), _c('br'), _c('label', [_vm._v("Company profile")])]), _vm._v(" "), _c('i', {
    staticClass: "zp1"
  }), _c('i', {
    staticClass: "zp2"
  }), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("糖糖圈是一个由中国慈展会认证，世界糖尿病基金会（WDF）资助，中国联合健康产业集团投资，中华医学会糖尿病分会1型学组、广东省糖尿病防治中心、广东省精准医学学会支持下成立的社会企业。")]), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("团队以解决中国1型糖尿病患者长期存活者少、血糖控制差、并发症多、经济负担重、教育机会少等社会问题为首要目标，通过移动互联网技术、可穿戴医疗设备、结合台湾糖尿病患教模式创新性的解决中国1型糖尿病管理现状的难题。")]), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("我们不仅针对1型糖尿病患者提供专业化患者教育、家庭教育、心理支持、血糖管理服务，而且努力在让1型糖尿病患者能够愉快、便捷的正常生活，免受疾病及并发症的干扰。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("1型糖尿病是一个终身性疾病，生活起来并不容易。需要患者与家属能够熟练掌握疾病知识，成为自己的医生，才能更好的享受生活。")]), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("为此，我们提供每周7天、每天24小时的应急响应支持，帮助患者及家属解决疾病带来的困难。")]), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("糖糖圈是中国1型糖尿病登记管理项目与中国1型糖尿病教育管理项目的参与者之一，欢迎您加入我们并在糖糖圈建档跟踪。我们将会有专业的患教师与您长期保持沟通。")]), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("通过我们远程教育跟踪以及同伴互助的方式，在糖糖圈的长期用户中，小于18岁患者的糖化血红蛋白达标率高达82.73%（A1C≤7.5%），大于18岁患者的糖化血红蛋白达标率高达88.82%（A1C≤7.5%），这无论是在国内还是国际上，都是极其好的结果。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "gs-cent",
    staticStyle: {
      "font-size": "18px",
      "color": "#000",
      "font-weight": "bold"
    }
  }, [_vm._v("社会责任")]), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("1.我们将致力于为儿童、青少年糖尿病患者及家庭提供支援；")]), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("2.凝聚社会力量以争取年轻患者在求学、求职中的合法权益；")]), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("3.推动、完善、建立1型糖尿病社会救助保障制度；")]), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("4.提升大众对1型糖尿病的理解，宣传治疗糖尿病的科学治疗方法。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "gs-cent",
    staticStyle: {
      "font-size": "18px",
      "color": "#000",
      "font-weight": "bold"
    }
  }, [_vm._v("科学研究")]), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("中国1型糖尿病登记管理项目")]), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("中国1型糖尿病教育管理项目")]), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("中国1型糖尿病合并妊娠结局研究项目")]), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("广东省1型糖尿病转化医学研究项目")]), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("广东省级科技项目：1型糖尿病病教育课程开发及科普平台建设")]), _vm._v(" "), _c('p', {
    staticClass: "gs-cent"
  }, [_vm._v("广东省级科技项目：1型糖尿病餐后血糖预测模型研究项目")])]), _vm._v(" "), _c('section', {
    staticClass: "contact"
  }, [_c('p', [_vm._v("400热线：400-836-5596")]), _vm._v(" "), _c('p', [_vm._v("客服电话：0755-27299992")]), _vm._v(" "), _c('p', [_vm._v("渠道合作：caoqifan@ttq.so")]), _vm._v(" "), _c('p', [_vm._v("微信客服：ttqcare")]), _vm._v(" "), _c('p', [_vm._v("地址：广东省深圳市宝安西乡街道宝民二路IDT研发中心4层")])]), _vm._v(" "), _c('section', {
    staticClass: "hs-box-s"
  }, [_c('p', {
    staticClass: "hs-logo2"
  }), _vm._v(" "), _c('p', {
    staticClass: "hs-end"
  }, [_vm._v("\n      爱宝惟生物科技有限公司版权所有\n      "), _c('span', {
    staticStyle: {
      "font-size": "14px",
      "margin-top": "15px"
    }
  }, [_vm._v("Copyright @ 2014-2024 aibaowei.All Rights Reserved"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.beian.miit.gov.cn"
    }
  }, [_vm._v("粤ICP备14072944号")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-990f37f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aboutUsHs.vue
// module id = 190
// module chunks = 1